const initiatePodcastModal = () => {

    const setup = () => {
        var modal = document.getElementById("podcastModal");
    
        if (modal) {
            var btn = document.getElementById("podcastModalButton");
            var closeBtn = document.getElementById("closeModalButton");
            var podcastYoutubeVideo = document.getElementById("podcastYoutubeVideo");
            var videoUrl = btn.getAttribute("data-youtube-url");
    
            // If the button exists, set up its click event
            if (btn) {
                btn.onclick = function () {
                    podcastYoutubeVideo.src = videoUrl;
                    modal.showModal();
                }
            }
    
            // When the user clicks the close button, close the modal and stop the video
            if (closeBtn) {
                closeBtn.onclick = function () {
                    modal.close();
                    podcastYoutubeVideo.src = "";
                }
            }
    
            // Close the modal when clicking outside of it
            modal.addEventListener('click', function (event) {
                if (event.target === modal) {
                    modal.close();
                    podcastYoutubeVideo.src = "";
                }
            });
        }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }

};


const initiateShareModal = () => {

    const setup = () => {
    const copyButton = document.getElementById('copyTextButton');
    if (copyButton) {
        copyButton.addEventListener('click', (event) => {
            const content = document.getElementById('urlSpan')?.textContent;
            if (content) {
                navigator.clipboard.writeText(content);
            }
        });
    }

    const modal = document.getElementById("modal");
    if (modal) {
        const openModal = document.getElementById("openModal");
        const closeModal = document.getElementById("closeModal");

        if (openModal) {
            openModal.addEventListener("click", () => {
                modal.showModal();
            });
        }

        if (closeModal) {
            closeModal.addEventListener("click", () => {
                modal.close();
            });
        }
    }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }

};



const init = () => {
	initiatePodcastModal();
    initiateShareModal();

};

export default {
	init
};